/** ========================================================================
 * Mixin usado nas páginas internas do hotel, armazena configurações
 * que são comuns a todas as páginas do hotel
 * ========================================================================= */
import { mapActions } from 'vuex'
import HotelNav from '@/components/hotel/HotelNav'
import PmwHotelNav from '@/components/hotel/PmwHotelNav'

/**
 * De para dos icones
 * TODO ver com o backend se é possível modificar o nome das classes
 */
const icons = {
  'edicao-hotel': 'pencil',
  quartos: 'bed',
  diferenciais: 'money-bag',
  tarifabase: 'rate-update',
  allotment: 'calendar-full',
  yields: 'gears',
  'forma-pagamento': 'credit-cards',
  taxas: 'percent',
  produtos: 'services',
  banners: 'pictures',
  pontos: 'pmw-settings-restore',
  'calendario-pontos': 'pmw-calendar-event'
}

export default {
  components: {
    HotelNav,
    PmwHotelNav
  },
  data() {
    return {
      /** Código do hotel */
      hotelId: this.$route.params.id,
      /** Lista de links do menu interno de hotel */
      menuLinks: []
    }
  },
  watch: {
    /** Detectar que há um hotelId, e formatar os links do menu */
    hotelId() {
      this.menuLinks = this.formattedMenu(this.menuLinks)
    }
  },
  created() {
    /** Buscar os items do menu */
    this.getMenu()
  },
  methods: {
    /** Buscar os items do menu */
    getMenu() {
      this.getHotelMenu().then((response) => {
        /** Formatar o menu */
        this.menuLinks = this.formattedMenu(response)
      })
    },
    /** Formatar os links do menu
     * @param {Array} links - Lista de itens do menu
     */
    formattedMenu(links) {
      return links.map((item) => {
        const obj = {
          /** Novos itens do menu a serem usados no componente */
          text: item.nome,
          link: this.getMenuLink(item.url),
          element: /^v2\//.test(item.url) ? 'router-link' : 'a',
          icon: icons[item.class],
          /** Itens do menu que serão reutilizados se o hotelId mudar */
          url: item.url,
          nome: item.nome,
          class: item.class
        }

        return obj
      })
    },
    /**
     * Extraí o link adaptado para o novo ou o velho admin
     * @param {String} url url do link
     * @returns {String} - o link padronizado
     */
    getMenuLink(url) {
      return `${url.replace('v2', '')}/${this.hotelId}`
    },
    ...mapActions('hotel', ['getHotelMenu'])
  }
}
